import React, { useState } from 'react';
import { Plus, Trash2, X } from 'lucide-react';
import ActionLinks from '../components/ActionLinks';
import FilterCard from '../components/FilterCard';
import TableLayout from '../components/TableLayout';

// 评议小组管理页面
// 页面结构：顶部 Tab + 条件筛选卡片 + 结果卡片
export default function PanelManagementPage() {
  // ================= 页面状态 =================
  const [activeTab, setActiveTab] = useState('小组管理');
  const [groupFormMode, setGroupFormMode] = useState('');
  const [isMemberDrawerOpen, setIsMemberDrawerOpen] = useState(false);
  const [isClassDrawerOpen, setIsClassDrawerOpen] = useState(false);

  // ================= 小组管理：筛选和表格配置 =================
  const groupFilterFields = [
    { label: '学年', type: 'select', options: ['全部', '2025-2026', '2024-2025'] },
    { label: '学期', type: 'select', options: ['全部', '第一学期', '第二学期'] },
    { label: '批次', type: 'select', options: ['全部', '第一批次', '第二批次'] },
    { label: '小组名称', type: 'input', placeholder: '请输入小组名称' },
  ];

  const groupTableHeaders = [
    '学年',
    '学期',
    '批次',
    '小组名称',
    '评议人员数量',
    '操作',
  ];

  const groupTableData = [
    [
      '2025-2026',
      '第一学期',
      '第一批次',
      '计科一班评议组',
      '5人',
      <ActionLinks
        links={[
          { text: '修改', onClick: () => setGroupFormMode('edit') },
          { text: '设置小组成员', onClick: () => setIsMemberDrawerOpen(true) },
          { text: '设置评定班级', onClick: () => setIsClassDrawerOpen(true) },
        ]}
      />,
    ],
    [
      '2025-2026',
      '第一学期',
      '第一批次',
      '计科二班评议组',
      '3人',
      <ActionLinks
        links={[
          { text: '修改', onClick: () => setGroupFormMode('edit') },
          { text: '设置小组成员', onClick: () => setIsMemberDrawerOpen(true) },
          { text: '设置评定班级', onClick: () => setIsClassDrawerOpen(true) },
        ]}
      />,
    ],
  ];

  // ================= 班级管理：筛选和表格配置 =================
  const classFilterFields = [
    { label: '学年', type: 'select', options: ['全部', '2025-2026'] },
    { label: '学期', type: 'select', options: ['全部', '第一学期', '第二学期'] },
    { label: '批次', type: 'select', options: ['全部', '第一批次'] },
    { label: '学院', type: 'select', options: ['全部', '计算机学院'] },
    { label: '是否已分配评议小组', type: 'select', options: ['全部', '是', '否'] },
    { label: '班级名称', type: 'input', placeholder: '请输入班级名称' },
    { label: '小组名称', type: 'input', placeholder: '请输入小组名称' },
  ];

  const classTableHeaders = [
    '学年',
    '学期',
    '批次',
    '学院',
    '年级',
    '专业',
    '班级',
    '是否分配',
    '所属评议小组',
    '操作',
  ];

  const classTableData = [
    [
      '25-26',
      '第一学期',
      '批次1',
      '计算机',
      '2024级',
      '软件工程',
      '计科1班',
      <span className="text-green-600">
        是
      </span>,
      '计科一班评议组',
      <ActionLinks
        links={[
          { text: '清空评议小组' },
        ]}
      />,
    ],
    [
      '25-26',
      '第一学期',
      '批次1',
      '计算机',
      '2024级',
      '软件工程',
      '计科2班',
      <span className="text-red-500">
        否
      </span>,
      '-',
      '-',
    ],
  ];

  return (
    <div className="animate-fade-in flex flex-col h-full">
      {/* 顶部 Tab：切换小组管理和班级管理两个视图 */}
      <div className="bg-white rounded-t shadow-sm border border-gray-100 p-4 pb-0 flex space-x-8 border-b">
        <button
          onClick={() => setActiveTab('小组管理')}
          className={`pb-3 cursor-pointer text-sm transition-colors ${activeTab === '小组管理' ? 'text-[#1890ff] border-b-2 border-[#1890ff]' : 'text-gray-600 hover:text-[#1890ff]'}`}
        >
          评议小组管理
        </button>
        <button
          onClick={() => setActiveTab('班级管理')}
          className={`pb-3 cursor-pointer text-sm transition-colors ${activeTab === '班级管理' ? 'text-[#1890ff] border-b-2 border-[#1890ff]' : 'text-gray-600 hover:text-[#1890ff]'}`}
        >
          评议班级管理
        </button>
      </div>

      {/* 小组管理视图 */}
      {activeTab === '小组管理' && (
        <div className="bg-transparent mt-4">
          {/* 条件筛选卡片：查询评议小组 */}
          <FilterCard fields={groupFilterFields} />

          {/* 结果卡片：评议小组列表 */}
          <div className="bg-white rounded shadow-sm border border-gray-100 p-4">
            <div className="flex space-x-3 mb-4">
              <button
                onClick={() => setGroupFormMode('add')}
                className="px-4 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]"
              >
                新增
              </button>
              <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50">
                删除
              </button>
            </div>

            <TableLayout
              selectable
              headers={groupTableHeaders}
              data={groupTableData}
            />
          </div>
        </div>
      )}

      {/* 班级管理视图 */}
      {activeTab === '班级管理' && (
        <div className="bg-transparent mt-4">
          {/* 条件筛选卡片：查询班级分配情况 */}
          <FilterCard fields={classFilterFields} />

          {/* 结果卡片：评议班级列表 */}
          <div className="bg-white rounded shadow-sm border border-gray-100 p-4">
            <div className="flex space-x-3 mb-4">
              {/* <button className="px-4 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]">
                批量分配小组
              </button> */}
              {/* <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50">
                批量清除
              </button> */}
            </div>

            <TableLayout
              selectable
              headers={classTableHeaders}
              data={classTableData}
            />
          </div>
        </div>
      )}

      {/* 右侧页面：新增/修改评议小组 */}
      {groupFormMode && (
        <GroupFormDrawer
          mode={groupFormMode}
          onClose={() => setGroupFormMode('')}
        />
      )}

      {/* 右侧页面：设置小组成员 */}
      {isMemberDrawerOpen && (
        <GroupMemberDrawer onClose={() => setIsMemberDrawerOpen(false)} />
      )}

      {/* 右侧页面：设置评定班级 */}
      {isClassDrawerOpen && (
        <GroupClassDrawer onClose={() => setIsClassDrawerOpen(false)} />
      )}
    </div>
  );
}

// 新增/修改评议小组页面
function GroupFormDrawer({ mode, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/30">
      <div className="w-[560px] h-full bg-[#f3f6fa] shadow-[-8px_0_24px_rgba(0,0,0,0.15)] flex flex-col">
        <DrawerHeader
          title={`${mode === 'add' ? '新增' : '修改'}评议小组`}
          onClose={onClose}
        />

        <div className="flex-1 overflow-y-auto p-6 space-y-5">
          {/* 基本信息卡片：填写小组名称并选择批次 */}
          <div className="bg-white rounded shadow-sm border border-gray-100 p-5 space-y-5">
            <FormInput
              label="评议小组名称"
              placeholder="请输入评议小组名称"
              defaultValue={mode === 'edit' ? '计科一班评议组' : ''}
            />
            <FormSelect
              label="批次"
              options={['第一批次', '第二批次']}
            />

            {/* 批次选择后自动带出的信息 */}
            <div className="grid grid-cols-2 gap-4 pt-2">
              <InfoItem label="学年" value="2025-2026" />
              <InfoItem label="学期" value="第一学期" />
            </div>
          </div>
        </div>

        <DrawerFooter onCancel={onClose} confirmText="保存" />
      </div>
    </div>
  );
}

// 设置小组成员页面
function GroupMemberDrawer({ onClose }) {
  const memberList = [
    {
      id: 1,
      name: '张三',
      staffNo: '202501',
      college: '计算机学院',
    },
    {
      id: 2,
      name: '李四',
      staffNo: '202502',
      college: '计算机学院',
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/30">
      <div
        className="h-full bg-[#f3f6fa] shadow-[-8px_0_24px_rgba(0,0,0,0.15)] flex flex-col"
        style={{ width: 'min(880px, calc((100vw - 240px) * 0.58))' }}
      >
        <DrawerHeader title="设置小组成员" onClose={onClose} />

        <div className="flex-1 overflow-y-auto p-6 space-y-5">
          {/* 小组基本信息卡片 */}
          <GroupBaseInfoCard />

          {/* 小组成员结果卡片 */}
          <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
            <div className="flex gap-2 mb-4">
              <button className="px-4 py-2 bg-[#1890ff] text-white rounded text-sm flex items-center gap-1 hover:bg-[#096dd9]">
                <Plus size={14} />
                添加
              </button>
              <button className="px-4 py-2 border border-red-300 text-red-500 rounded text-sm flex items-center gap-1 hover:bg-red-50">
                <Trash2 size={14} />
                删除
              </button>
            </div>

            <div className="overflow-x-auto border border-gray-200 rounded">
              <table className="w-full text-left border-collapse text-[13px] text-gray-700 whitespace-nowrap">
                <thead>
                  <tr className="bg-[#fafafa] border-b border-gray-200">
                    <th className="py-3 px-4 w-10">
                      <input type="checkbox" />
                    </th>
                    <TableHead>序号</TableHead>
                    <TableHead>姓名</TableHead>
                    <TableHead>学号</TableHead>
                    <TableHead>学院</TableHead>
                  </tr>
                </thead>
                <tbody>
                  {memberList.map((row, index) => (
                    <tr key={row.id} className="border-b border-gray-100 hover:bg-[#f8f9fa]">
                      <td className="py-3 px-4">
                        <input type="checkbox" />
                      </td>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.name}</TableCell>
                      <TableCell>{row.staffNo}</TableCell>
                      <TableCell>{row.college}</TableCell>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// 设置评定班级页面
function GroupClassDrawer({ onClose }) {
  const classList = [
    {
      id: 1,
      college: '计算机学院',
      grade: '2024级',
      major: '软件工程',
      className: '计科1班',
      studentCount: 50,
    },
    {
      id: 2,
      college: '计算机学院',
      grade: '2024级',
      major: '软件工程',
      className: '计科2班',
      studentCount: 48,
    },
  ];

  return (
    <div className="fixed inset-0 z-50 flex justify-end bg-black/30">
      <div
        className="h-full bg-[#f3f6fa] shadow-[-8px_0_24px_rgba(0,0,0,0.15)] flex flex-col"
        style={{ width: 'min(880px, calc((100vw - 240px) * 0.58))' }}
      >
        <DrawerHeader title="设置评定班级" onClose={onClose} />

        <div className="flex-1 overflow-y-auto p-6 space-y-5">
          {/* 小组基本信息卡片 */}
          <GroupBaseInfoCard />

          {/* 评定班级结果卡片 */}
          <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
            <div className="flex gap-2 mb-4">
              <button className="px-4 py-2 bg-[#1890ff] text-white rounded text-sm flex items-center gap-1 hover:bg-[#096dd9]">
                <Plus size={14} />
                添加
              </button>
              <button className="px-4 py-2 border border-red-300 text-red-500 rounded text-sm flex items-center gap-1 hover:bg-red-50">
                <Trash2 size={14} />
                删除
              </button>
            </div>

            <div className="overflow-x-auto border border-gray-200 rounded">
              <table className="w-full text-left border-collapse text-[13px] text-gray-700 whitespace-nowrap">
                <thead>
                  <tr className="bg-[#fafafa] border-b border-gray-200">
                    <th className="py-3 px-4 w-10">
                      <input type="checkbox" />
                    </th>
                    <TableHead>序号</TableHead>
                    <TableHead>学院</TableHead>
                    <TableHead>年级</TableHead>
                    <TableHead>专业</TableHead>
                    <TableHead>班级</TableHead>
                    <TableHead>班级人数</TableHead>
                  </tr>
                </thead>
                <tbody>
                  {classList.map((row, index) => (
                    <tr key={row.id} className="border-b border-gray-100 hover:bg-[#f8f9fa]">
                      <td className="py-3 px-4">
                        <input type="checkbox" />
                      </td>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.college}</TableCell>
                      <TableCell>{row.grade}</TableCell>
                      <TableCell>{row.major}</TableCell>
                      <TableCell>{row.className}</TableCell>
                      <TableCell>{row.studentCount}</TableCell>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// 小组基本信息卡片
function GroupBaseInfoCard() {
  return (
    <div className="bg-white rounded shadow-sm border border-gray-100 p-5">
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-x-8 gap-y-4 text-sm">
        <InfoItem label="学年" value="2025-2026" />
        <InfoItem label="学期" value="第一学期" />
        <InfoItem label="批次名称" value="第一批次" />
        <InfoItem label="小组名称" value="计科一班评议组" />
      </div>
    </div>
  );
}

// 抽屉标题栏
function DrawerHeader({ title, onClose }) {
  return (
    <div className="h-[58px] px-6 bg-white border-b border-gray-200 flex items-center justify-between">
      <h2 className="text-[16px] font-bold text-gray-900">
        {title}
      </h2>
      <button
        onClick={onClose}
        className="text-gray-400 hover:text-gray-600"
      >
        <X size={20} />
      </button>
    </div>
  );
}

// 抽屉底部按钮
function DrawerFooter({ onCancel, confirmText }) {
  return (
    <div className="h-[64px] px-6 bg-white border-t border-gray-200 flex justify-end items-center gap-3">
      <button
        onClick={onCancel}
        className="px-5 py-2 border border-gray-300 text-gray-700 rounded text-sm hover:bg-gray-50"
      >
        取消
      </button>
      <button
        onClick={onCancel}
        className="px-5 py-2 bg-[#1890ff] text-white rounded text-sm hover:bg-[#096dd9]"
      >
        {confirmText}
      </button>
    </div>
  );
}

// 表单输入框
function FormInput({ label, placeholder, defaultValue = '' }) {
  return (
    <label className="block">
      <span className="block text-sm text-gray-700 mb-2">
        {label}：
      </span>
      <input
        defaultValue={defaultValue}
        placeholder={placeholder}
        className="w-full border border-gray-300 rounded px-3 py-2 text-sm outline-none focus:border-[#1890ff]"
      />
    </label>
  );
}

// 表单下拉框
function FormSelect({ label, options }) {
  return (
    <label className="block">
      <span className="block text-sm text-gray-700 mb-2">
        {label}：
      </span>
      <select className="w-full border border-gray-300 rounded px-3 py-2 text-sm outline-none focus:border-[#1890ff] bg-white text-gray-700">
        {options.map((option) => (
          <option key={option}>{option}</option>
        ))}
      </select>
    </label>
  );
}

// 信息展示项
function InfoItem({ label, value }) {
  return (
    <div>
      <div className="text-gray-400 mb-1">
        {label}
      </div>
      <div className="text-gray-800">
        {value}
      </div>
    </div>
  );
}

// 表格表头
function TableHead({ children }) {
  return (
    <th className="py-3 px-4 font-medium text-gray-800">
      {children}
    </th>
  );
}

// 表格单元格
function TableCell({ children }) {
  return (
    <td className="py-3 px-4">
      {children}
    </td>
  );
}
